var _indexOf =
/*#__PURE__*/
require("./_indexOf");

function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}

module.exports = _includes;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_includes.js
// module id = 215
// module chunks = 0